import React from "react";
import Typography from "@material-ui/core/Typography";
import { languages } from "../../../constants/languages";
import EditDiaContainer from "../../../containers/settings/slideshow/EditDiaContainer";
import Paper from "@material-ui/core/Paper";
import { withTheme } from "@material-ui/core/styles";
import StructureElementsNotDivided from "./StructureElementsNotDivided";
import SponsorsIcon from "@material-ui/icons/PhotoLibrary";
import DressingRoomIcon from "@material-ui/icons/MeetingRoom";
import TeamLayoutsIcon from "@material-ui/icons/Group";
import Icon from "@mdi/react";
import { mdiScoreboard } from "@mdi/js";
import ScheduleIcon from "@material-ui/icons/Schedule";
import Checkbox from "@material-ui/core/Checkbox";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import DiaPhotoContainer from "../../../containers/settings/slideshow/DiaPhotoContainer";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import moment from "moment-timezone";
import { DragDropContext, Droppable } from "react-beautiful-dnd";
import DiaElement from "./DiaElement";
import NumRowsPerFontSize from "../../../constants/NumRowsPerFontSize";
import RankingContainer from "../../../containers/settings/slideshow/RankingContainer";
import PlayerStatsContainer from "../../../containers/settings/slideshow/PlayerStatsContainer";
import DiaTextContainer from "../../../containers/settings/slideshow/DiaTextContainer";
import { mdiQrcode } from "@mdi/js";

class Dia extends React.Component {
  state = {
    anchorEl: null,
    anchorElDressingRooms: null,
    anchorElTeamLayouts: null,
    anchorElUpcomingMatches: null,
    anchorElRecentResults: null,
    structureElementsTemp: undefined,
  };

  openMenu = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  closeMenu = () => {
    this.setState({ anchorEl: null });
  };

  openMenuDressingRooms = (event) => {
    this.setState({ anchorElDressingRooms: event.currentTarget });
  };

  openMenuTeamLayouts = (event) => {
    this.setState({ anchorElTeamLayouts: event.currentTarget });
  };

  closeMenuDressingRooms = () => {
    this.setState({ anchorElDressingRooms: null });
  };

  closeMenuTeamLayouts = () => {
    this.setState({ anchorElTeamLayouts: null });
  };

  openMenuUpcomingMatches = (event) => {
    this.setState({ anchorElUpcomingMatches: event.currentTarget });
  };

  closeMenuUpcomingMatches = () => {
    this.setState({ anchorElUpcomingMatches: null });
  };

  openMenuRecentResults = (event) => {
    this.setState({ anchorElRecentResults: event.currentTarget });
  };

  closeMenuRecentResults = () => {
    this.setState({ anchorElRecentResults: null });
  };

  UNSAFE_componentWillMount = () => {
    this.setState({
      diaText: this.props.dia.diaText || "",
      diaTextTitle: this.props.dia.diaTextTitle || "",
    });
  };

  handleWidthChange = (event) => {
    let newState = {};
    newState[event.target.name] = event.target.value;
    window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .collection("dias")
      .doc(this.props.dia.id)
      .update(newState);
  };

  handleAddDressingRoomLayout = (e, i, divisionId) => {
    e.preventDefault();

    let numInDia =
      this.props.dia[
        "diaDressingRoomIndex" +
          (divisionId === "0" ? i.toString() : divisionId + i.toString())
      ];
    if (numInDia === null || numInDia === undefined) {
      numInDia = 0;
      if (this.props.structureElements.length > 0) {
        let lastElement =
          this.props.structureElements[
            this.props.structureElements.length - 1
          ] || {};
        numInDia =
          lastElement[
            lastElement.numInDiaLocal !== undefined
              ? "numInDiaLocal"
              : "numInDia"
          ] + 1;
      }
    }

    let toUpdate = {};
    // toUpdate["diaDressingRoom" + (divisionId === "0" ? "" : divisionId)] = i;
    toUpdate[
      "diaDressingRoomIndex" +
        (divisionId === "0" ? i.toString() : divisionId + i.toString())
    ] = numInDia;

    window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .collection("dias")
      .doc(this.props.dia.id)
      .update(toUpdate);
  };

  handleAddTeamLayout = (e, i, divisionId) => {
    e.preventDefault();

    let numInDia =
      this.props.dia[
        "diaTeamLayoutIndex" +
          (divisionId === "0" ? i.toString() : divisionId + i.toString())
      ];
    if (numInDia === null || numInDia === undefined) {
      numInDia = 0;
      if (this.props.structureElements.length > 0) {
        let lastElement =
          this.props.structureElements[
            this.props.structureElements.length - 1
          ] || {};
        numInDia =
          lastElement[
            lastElement.numInDiaLocal !== undefined
              ? "numInDiaLocal"
              : "numInDia"
          ] + 1;
      }
    }

    let toUpdate = {};
    // toUpdate["diaDressingRoom" + (divisionId === "0" ? "" : divisionId)] = i;
    toUpdate[
      "diaTeamLayoutIndex" +
        (divisionId === "0" ? i.toString() : divisionId + i.toString())
    ] = numInDia;

    window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .collection("dias")
      .doc(this.props.dia.id)
      .update(toUpdate);
  };

  handleAddUpcomingMatches = (e, sportParkId) => {
    e.preventDefault();

    let numInDia = this.props.dia["diaUpcomingMatchesIndex" + sportParkId];
    if (numInDia === null || numInDia === undefined) {
      numInDia = 0;
      if (this.props.structureElements.length > 0) {
        let lastElement =
          this.props.structureElements[
            this.props.structureElements.length - 1
          ] || {};
        numInDia =
          lastElement[
            lastElement.numInDiaLocal !== undefined
              ? "numInDiaLocal"
              : "numInDia"
          ] + 1;
      }
    }

    let toUpdate = {};
    toUpdate["diaUpcomingMatchesIndex" + sportParkId] = numInDia;

    window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .collection("dias")
      .doc(this.props.dia.id)
      .update(toUpdate);
  };

  handleAddRecentResults = (e, sportParkId) => {
    e.preventDefault();

    let numInDia = this.props.dia["diaRecentResultsIndex" + sportParkId];
    if (numInDia === null || numInDia === undefined) {
      numInDia = 0;
      if (this.props.structureElements.length > 0) {
        let lastElement =
          this.props.structureElements[
            this.props.structureElements.length - 1
          ] || {};
        numInDia =
          lastElement[
            lastElement.numInDiaLocal !== undefined
              ? "numInDiaLocal"
              : "numInDia"
          ] + 1;
      }
    }

    let toUpdate = {};
    toUpdate["diaRecentResultsIndex" + sportParkId] = numInDia;

    window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .collection("dias")
      .doc(this.props.dia.id)
      .update(toUpdate);
  };

  onDragEnd = (result) => {
    this.props.setDraggingWithinDia(null);
    if (!result.destination) {
      return;
    }

    const structureElements = this.props.structureElements.slice();
    const [removed] = structureElements.splice(result.source.index, 1);
    structureElements.splice(result.destination.index, 0, removed);

    const db = window.firebase.firestore();
    let batch = db.batch();
    const tournamentRef = db
      .collection("tournaments")
      .doc(this.props.tournament[".key"]);
    const diaRef = tournamentRef.collection("dias").doc(this.props.dia.id);
    let structureElementsTemp = [];
    structureElements.forEach((l, i) => {
      let structureElement = structureElements[i];
      if (structureElement.isSponsors) {
        let toUpdate = {};
        toUpdate["sponsorIndex" + structureElement.sponsorNum] = i;
        batch.update(diaRef, toUpdate);
      } else if (structureElement.isText) {
        let toUpdate = {};
        toUpdate["diaTextIndex" + structureElement.textNum] = i;
        batch.update(diaRef, toUpdate);
      } else if (structureElement.isPicture) {
        let toUpdate = {};
        toUpdate["diaPhotoIndex" + structureElement.photoNum] = i;
        batch.update(diaRef, toUpdate);
      } else if (structureElement.isQRCode) {
        batch.update(diaRef, { qrCodeIndex: i });
      } else if (structureElement.isDressingRooms) {
        let toUpdate = {};
        toUpdate[
          "diaDressingRoomIndex" +
            (structureElement.divisionId === "0"
              ? structureElement.layoutNum.toString()
              : structureElement.divisionId +
                structureElement.layoutNum.toString())
        ] = i;
        batch.update(diaRef, toUpdate);
      } else if (structureElement.isTeamLayouts) {
        let toUpdate = {};
        toUpdate[
          "diaTeamLayoutIndex" +
            (structureElement.divisionId === "0"
              ? structureElement.layoutNum.toString()
              : structureElement.divisionId +
                structureElement.layoutNum.toString())
        ] = i;
        batch.update(diaRef, toUpdate);
      } else if (structureElement.isUpcomingMatches) {
        let toUpdate = {};
        toUpdate["diaUpcomingMatchesIndex" + structureElement.sportParkId] = i;
        batch.update(diaRef, toUpdate);
      } else if (structureElement.isRecentResults) {
        let toUpdate = {};
        toUpdate["diaRecentResultsIndex" + structureElement.sportParkId] = i;
        batch.update(diaRef, toUpdate);
      } else if (structureElement.isRanking) {
        let toUpdate = {};
        toUpdate[
          "diaRankingIndex" +
            structureElement.divisionId +
            structureElement.rankingNum.toString()
        ] = i;
        batch.update(diaRef, toUpdate);
      } else if (structureElement.isPlayerStats) {
        let toUpdate = {};
        toUpdate[
          "diaPlayerStatsIndex" +
            structureElement.divisionId +
            "_" +
            structureElement.statKey
        ] = i;
        batch.update(diaRef, toUpdate);
      } else {
        let toUpdate = {};
        let keyName = "numInDia";
        if (structureElement.diaNum !== undefined) {
          keyName += structureElement.diaNum.toString();
        }
        toUpdate[keyName] = i;
        if (structureElement.isBracket) {
          batch.update(
            tournamentRef.collection("brackets").doc(structureElement.id),
            toUpdate
          );
        } else {
          batch.update(
            tournamentRef.collection("poules").doc(structureElement.id),
            toUpdate
          );
        }
      }
      structureElementsTemp.push(structureElement);
    });
    this.setState({ structureElementsTemp: structureElementsTemp });
    batch
      .commit()
      .catch((error) => {
        console.log(error.message);
        this.setState({ structureElementsTemp: undefined });
      })
      .then(() => {
        this.setState({ structureElementsTemp: undefined });
      });
  };

  onDragStart = (start) => {
    this.props.setDraggingWithinDia(this.props.dia.id);
  };

  render() {
    let sponsors = [];
    let firstBlockName = (this.props.tournament.sponsorBlockNames || {})[0]
      ? (this.props.tournament.sponsorBlockNames || {})[0]
      : languages.tournament.sponsorGroup + " 1";
    if ((this.props.tournament.sponsors || []).length > 0) {
      sponsors.push([this.props.tournament.sponsors || [], 0, firstBlockName]);
    }
    let blockNames = { 0: firstBlockName };
    for (let i = 1; i < 100; i++) {
      if (
        this.props.tournament["sponsors" + i.toString()] &&
        (this.props.tournament["sponsors" + i.toString()] || []).length > 0
      ) {
        let blockName = (this.props.tournament.sponsorBlockNames || {})[i]
          ? (this.props.tournament.sponsorBlockNames || {})[i]
          : languages.tournament.sponsorGroup + " " + (i + 1).toString();
        blockNames[i.toString()] = blockName;
        sponsors.push([
          this.props.tournament["sponsors" + i.toString()],
          i,
          blockName,
        ]);
      }
    }

    let sponsorOrder =
      this.props.tournament.sponsorBlockOrder || sponsors.map((s, i) => i);
    sponsors.sort((a, b) => {
      let indexA =
        sponsorOrder.indexOf(a[1]) !== -1 ? sponsorOrder.indexOf(a[1]) : 9999;
      let indexB =
        sponsorOrder.indexOf(b[1]) !== -1 ? sponsorOrder.indexOf(b[1]) : 9999;
      return indexA - indexB;
    });

    let showQRCodeButton =
      this.props.dia["qrCodeIndex"] === null ||
      this.props.dia["qrCodeIndex"] === undefined;
    let showDressingRoomsButton = true;
    //   this.props.dia["diaDressingRoomIndex"] === null ||
    //   this.props.dia["diaDressingRoomIndex"] === undefined;
    // if (this.props.divisions.length > 1) {
    //   showDressingRoomsButton = true;
    // }

    let dressingRoomLayoutsPerDivision = {};
    let dressingRoomMenuItems = [];
    let teamLayoutsPerDivision = {};
    let teamLayoutsMenuItems = [];
    let fontSize =
      (this.props.slideshowsByKey[this.props.selectedSlideshow] || {})
        .slideshowFontSize || "1";
    if (this.props.selectedSlideshow === "0") {
      fontSize = this.props.tournament.slideshowFontSize || "1";
    }
    let maxTeamsDressingRooms = NumRowsPerFontSize[Number(fontSize)];
    this.props.divisions.forEach((division) => {
      let numDressingRoomLayouts = Math.ceil(
        this.props.teams.filter((t) => t.division === division.id).length /
          maxTeamsDressingRooms
      );
      let numTeamLayouts = Math.ceil(
        this.props.players.filter(
          (t) => (this.props.teamsByKey[t.team] || {}).division === division.id
        ).length / maxTeamsDressingRooms
      );
      if (dressingRoomLayoutsPerDivision[division.id] === undefined) {
        dressingRoomLayoutsPerDivision[division.id] = [];
      }
      for (let i = 0; i < numDressingRoomLayouts; i++) {
        dressingRoomLayoutsPerDivision[division.id].push(i);
      }
      if (teamLayoutsPerDivision[division.id] === undefined) {
        teamLayoutsPerDivision[division.id] = [];
      }
      for (let i = 0; i < numTeamLayouts; i++) {
        teamLayoutsPerDivision[division.id].push(i);
      }

      let menuItems = dressingRoomLayoutsPerDivision[division.id].map((i) => {
        return (
          <MenuItem
            key={division.id + i}
            style={{
              height: 30,
              padding: "0 40px 0 10px",
            }}
            onClick={(e) => {
              this.closeMenuDressingRooms();
              this.handleAddDressingRoomLayout(e, i, division.id);
            }}
            disabled={
              this.props.dia[
                "diaDressingRoomIndex" +
                  (division.id === "0"
                    ? i.toString()
                    : division.id + i.toString())
              ] !== null &&
              this.props.dia[
                "diaDressingRoomIndex" +
                  (division.id === "0"
                    ? i.toString()
                    : division.id + i.toString())
              ] !== undefined
            }
          >
            {languages.teams.dressingRoomLayout +
              (this.props.divisions.length > 1
                ? " (" + division.name + ") "
                : " ") +
              (numDressingRoomLayouts > 1
                ? "(" +
                  (i + 1).toString() +
                  "/" +
                  numDressingRoomLayouts.toString() +
                  ")"
                : "")}
          </MenuItem>
        );
      });
      dressingRoomMenuItems = dressingRoomMenuItems.concat(menuItems);

      let menuItemsTeamLayouts = teamLayoutsPerDivision[division.id].map(
        (i) => {
          return (
            <MenuItem
              key={division.id + i}
              style={{
                height: 30,
                padding: "0 40px 0 10px",
              }}
              onClick={(e) => {
                this.closeMenuTeamLayouts();
                this.handleAddTeamLayout(e, i, division.id);
              }}
              disabled={
                this.props.dia[
                  "diaTeamLayoutIndex" +
                    (division.id === "0"
                      ? i.toString()
                      : division.id + i.toString())
                ] !== null &&
                this.props.dia[
                  "diaTeamLayoutIndex" +
                    (division.id === "0"
                      ? i.toString()
                      : division.id + i.toString())
                ] !== undefined
              }
            >
              {languages.teams.squadList +
                (this.props.divisions.length > 1
                  ? " (" + division.name + ") "
                  : " ") +
                (numTeamLayouts > 1
                  ? "(" +
                    (i + 1).toString() +
                    "/" +
                    numTeamLayouts.toString() +
                    ")"
                  : "")}
            </MenuItem>
          );
        }
      );
      teamLayoutsMenuItems = teamLayoutsMenuItems.concat(menuItemsTeamLayouts);
    });

    let upcomingMatchesMenuItems = [];
    let showUpcomingButton =
      this.props.dia["diaUpcomingMatchesIndex0"] === null ||
      this.props.dia["diaUpcomingMatchesIndex0"] === undefined;
    if (this.props.sportParks.length > 1 && !this.props.tournament.online) {
      showUpcomingButton = true;
    }
    this.props.sportParks.forEach((sportPark) => {
      upcomingMatchesMenuItems.push(
        <MenuItem
          key={sportPark.id}
          style={{
            height: 30,
            padding: "0 40px 0 10px",
          }}
          onClick={(e) => {
            this.closeMenuUpcomingMatches();
            this.handleAddUpcomingMatches(e, sportPark.id);
          }}
          disabled={
            this.props.dia["diaUpcomingMatchesIndex" + sportPark.id] !== null &&
            this.props.dia["diaUpcomingMatchesIndex" + sportPark.id] !==
              undefined
          }
        >
          {languages.schedule.upcomingMatches +
            (this.props.sportParks.length > 1 && " (" + sportPark.name + ")")}
        </MenuItem>
      );
    });

    let recentResultsMenuItems = [];
    let showRecentResultsButton =
      this.props.dia["diaRecentResultsIndex0"] === null ||
      this.props.dia["diaRecentResultsIndex0"] === undefined;
    if (this.props.sportParks.length > 1 && !this.props.tournament.online) {
      showRecentResultsButton = true;
    }
    this.props.sportParks.forEach((sportPark) => {
      recentResultsMenuItems.push(
        <MenuItem
          key={sportPark.id}
          style={{
            height: 30,
            padding: "0 40px 0 10px",
          }}
          onClick={(e) => {
            this.closeMenuRecentResults();
            this.handleAddRecentResults(e, sportPark.id);
          }}
          disabled={
            this.props.dia["diaRecentResultsIndex" + sportPark.id] !== null &&
            this.props.dia["diaRecentResultsIndex" + sportPark.id] !== undefined
          }
        >
          {languages.schedule.recentResults +
            (this.props.sportParks.length > 1 && " (" + sportPark.name + ")")}
        </MenuItem>
      );
    });

    return (
      <Paper
        style={{
          width: "100%",
          height: "100%",
        }}
      >
        <div
          {...this.props.provided.dragHandleProps}
          style={{
            background: this.props.theme.palette.primary.main,
            display: "flex",
            alignItems: "center",
            height: 30,
            paddingLeft: 10,
            borderRadius: "4px 4px 0px 0px",
          }}
        >
          <Typography
            variant="body2"
            style={{
              color: "white",
              fontWeight: 500,
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {languages.present.dia +
              " " +
              Number(this.props.num + 1) +
              ": " +
              this.props.dia.time +
              " " +
              languages.present.seconds}
          </Typography>

          <div style={{ flex: "1 1 1%" }} />
          {this.props.days.length > 0 && (
            <span
              style={{
                borderStyle: "solid",
                borderWidth: "0px 1px 0px 1px",
                color: "white",
                whiteSpace: "nowrap",
                marginRight: 7,
                padding: 5,
              }}
            >
              <Typography variant="body2" style={{ color: "white" }}>
                {!this.props.dia.day
                  ? languages.present.allDays
                  : this.props.dia.day === "0"
                  ? moment
                      .unix(this.props.tournament.date)
                      .tz(this.props.tournament.timezone || "Europe/Amsterdam")
                      .format(languages.createTournament.dateFormat)
                  : this.props.daysByKey[this.props.dia.day]
                  ? moment
                      .unix(
                        (this.props.daysByKey[this.props.dia.day] || {}).date
                      )
                      .tz(this.props.tournament.timezone || "Europe/Amsterdam")
                      .format(languages.createTournament.dateFormat)
                  : languages.present.allDays}
              </Typography>
            </span>
          )}
          <Typography variant="body2" style={{ color: "white" }}>
            {languages.present.active + ":"}
          </Typography>
          <Checkbox
            checked={this.props.dia.active}
            onClick={(event) => {
              this.props.handleActiveCheck(event, this.props.dia.id);
            }}
            style={{ height: 35, width: 35, color: "white" }}
            disabled={this.props.dia.isPSD}
          />
          <EditDiaContainer
            tournament={this.props.tournament}
            dia={this.props.dia}
            dias={this.props.dias}
            days={this.props.days}
            daysByKey={this.props.daysByKey}
          />
        </div>
        <div
          style={{
            whiteSpace: "nowrap",
          }}
        >
          <DragDropContext
            onDragStart={this.onDragStart}
            onDragEnd={this.onDragEnd}
          >
            <div style={{ width: "100%" }}>
              <Droppable droppableId="diaElementDrop">
                {(provided, snapshot) => {
                  return (
                    <div ref={provided.innerRef}>
                      {(this.state.structureElementsTemp
                        ? this.state.structureElementsTemp
                        : this.props.structureElements
                      ).map((structureElement, i) => {
                        return (
                          <DiaElement
                            index={i}
                            dia={this.props.dia}
                            user={this.props.user}
                            userData={this.props.userData}
                            userStatus={this.props.userStatus}
                            tournamentStatus={this.props.tournamentStatus}
                            blockNames={blockNames}
                            key={
                              structureElement.id +
                              (structureElement.diaNum !== undefined
                                ? structureElement.diaNum.toString()
                                : "")
                            }
                            sponsors={sponsors}
                            tournament={this.props.tournament}
                            structureElement={structureElement}
                            toggleDiaTextDialog={this.toggleDiaTextDialog}
                            structureElements={this.props.structureElements}
                            handleWidthChange={this.handleWidthChange}
                            isDraggingWithinDia={this.props.isDraggingWithinDia}
                            handleTeamLayoutsSortChange={
                              this.props.handleTeamLayoutsSortChange
                            }
                          />
                        );
                      })}
                      {provided.placeholder}
                    </div>
                  );
                }}
              </Droppable>
            </div>
          </DragDropContext>

          {!this.props.dia.isPSD && (
            <div
              style={{ textAlign: "center", paddingTop: 5, paddingBottom: 5 }}
            >
              <StructureElementsNotDivided
                tournament={this.props.tournament}
                dia={this.props.dia}
                structureElementsNotDivided={
                  this.props.structureElementsNotDivided
                }
                structureElements={this.props.structureElements}
                diasByKey={this.props.diasByKey}
              />
              {/* {this.props.dia.sponsorIndex === null && ( */}
              <div style={{ display: "inline-block" }}>
                <Tooltip title={languages.present.sponsors}>
                  <span>
                    <IconButton
                      onClick={(e) => {
                        sponsors.length > 1
                          ? this.openMenu(e)
                          : this.props.handleAddSponsors(
                              e,
                              this.props.dia.id,
                              this.props.structureElements,
                              null
                            );
                      }}
                      disabled={
                        (this.props.tournament.sponsors || []).length === 0
                      }
                      size="small"
                    >
                      <SponsorsIcon style={{ height: 20, width: 20 }} />
                    </IconButton>
                  </span>
                </Tooltip>
                {sponsors.length > 1 && (
                  <Menu
                    id="lock-menu"
                    anchorEl={this.state.anchorEl}
                    open={Boolean(this.state.anchorEl)}
                    onClose={this.closeMenu}
                    PaperProps={{
                      style: {
                        maxHeight: 30 * 6,
                        minWidth: 180,
                      },
                    }}
                  >
                    {sponsors.map((extraSponsor, index) => {
                      return (
                        <MenuItem
                          style={{
                            height: 30,
                            padding: "0 40px 0 10px",
                          }}
                          key={index}
                          onClick={(e) => {
                            this.closeMenu();
                            this.props.handleAddSponsors(
                              e,
                              this.props.dia.id,
                              this.props.structureElements,
                              extraSponsor[1] === 0 ? null : extraSponsor[1]
                            );
                          }}
                        >
                          {extraSponsor[2]}
                        </MenuItem>
                      );
                    })}
                  </Menu>
                )}
              </div>
              {/* )} */}
              <DiaTextContainer
                tournament={this.props.tournament}
                dia={this.props.dia}
                structureElements={this.props.structureElements}
              />

              <DiaPhotoContainer
                tournament={this.props.tournament}
                dia={this.props.dia}
                structureElements={this.props.structureElements}
                user={this.props.user}
                userData={this.props.userData}
                userStatus={this.props.userStatus}
                tournamentStatus={this.props.tournamentStatus}
              />
              {showQRCodeButton && (
                <div style={{ display: "inline-block" }}>
                  <Tooltip title={languages.tournament.qrCode}>
                    <span>
                      <IconButton
                        onClick={(e) => {
                          this.props.handleAddQRCode(
                            e,
                            this.props.dia.id,
                            this.props.structureElements
                          );
                        }}
                        size="small"
                      >
                        <Icon
                          path={mdiQrcode}
                          color="rgba(0, 0, 0, 0.54)"
                          style={{ height: 20, width: 20 }}
                        />
                      </IconButton>
                    </span>
                  </Tooltip>
                </div>
              )}
              {showDressingRoomsButton &&
                (
                  (this.props.tournament.defaultFields || {})["dressingRoom"] ||
                  {}
                ).show && (
                  <div style={{ display: "inline-block" }}>
                    <Tooltip title={languages.teams.dressingRoomLayout}>
                      <IconButton
                        onClick={(e) => {
                          this.openMenuDressingRooms(e);
                        }}
                        size="small"
                      >
                        <DressingRoomIcon style={{ height: 20, width: 20 }} />
                      </IconButton>
                    </Tooltip>
                    <Menu
                      id="lock-menu"
                      anchorEl={this.state.anchorElDressingRooms}
                      open={Boolean(this.state.anchorElDressingRooms)}
                      onClose={this.closeMenuDressingRooms}
                      PaperProps={{
                        style: {
                          maxHeight: 30 * 6,
                          minWidth: 180,
                        },
                      }}
                    >
                      {dressingRoomMenuItems}
                    </Menu>
                  </div>
                )}
              {this.props.players.length > 0 &&
                (((this.props.tournament.defaultFields || {})["players"] || {})
                  .show ||
                  (this.props.tournament.defaultFields || {})["players"] ===
                    undefined) &&
                !this.props.tournament.individualPlayers && (
                  <div style={{ display: "inline-block" }}>
                    <Tooltip title={languages.teams.squadList}>
                      <IconButton
                        onClick={(e) => {
                          this.openMenuTeamLayouts(e);
                        }}
                        size="small"
                      >
                        <TeamLayoutsIcon style={{ height: 20, width: 20 }} />
                      </IconButton>
                    </Tooltip>
                    <Menu
                      id="lock-menu"
                      anchorEl={this.state.anchorElTeamLayouts}
                      open={Boolean(this.state.anchorElTeamLayouts)}
                      onClose={this.closeMenuTeamLayouts}
                      PaperProps={{
                        style: {
                          maxHeight: 30 * 6,
                          minWidth: 180,
                        },
                      }}
                    >
                      {teamLayoutsMenuItems}
                    </Menu>
                  </div>
                )}
              {showUpcomingButton && (
                <div style={{ display: "inline-block" }}>
                  <Tooltip title={languages.schedule.upcomingMatches}>
                    <IconButton
                      onClick={(e) => {
                        this.props.sportParks.length > 1
                          ? this.openMenuUpcomingMatches(e)
                          : this.handleAddUpcomingMatches(e, "0");
                      }}
                      size="small"
                    >
                      <ScheduleIcon style={{ height: 20, width: 20 }} />
                    </IconButton>
                  </Tooltip>
                  {this.props.sportParks.length > 1 && (
                    <Menu
                      id="lock-menu"
                      anchorEl={this.state.anchorElUpcomingMatches}
                      open={Boolean(this.state.anchorElUpcomingMatches)}
                      onClose={this.closeMenuUpcomingMatches}
                      PaperProps={{
                        style: {
                          maxHeight: 30 * 6,
                          minWidth: 180,
                        },
                      }}
                    >
                      {upcomingMatchesMenuItems}
                    </Menu>
                  )}
                </div>
              )}
              {showRecentResultsButton && (
                <div style={{ display: "inline-block" }}>
                  <Tooltip title={languages.schedule.recentResults}>
                    <IconButton
                      onClick={(e) => {
                        this.props.sportParks.length > 1
                          ? this.openMenuRecentResults(e)
                          : this.handleAddRecentResults(e, "0");
                      }}
                      size="small"
                    >
                      <Icon
                        path={mdiScoreboard}
                        color="rgba(0, 0, 0, 0.54)"
                        style={{ height: 20, width: 20 }}
                      />
                    </IconButton>
                  </Tooltip>
                  {this.props.sportParks.length > 1 && (
                    <Menu
                      id="lock-menu"
                      anchorEl={this.state.anchorElRecentResults}
                      open={Boolean(this.state.anchorElRecentResults)}
                      onClose={this.closeMenuRecentResults}
                      PaperProps={{
                        style: {
                          maxHeight: 30 * 6,
                          minWidth: 180,
                        },
                      }}
                    >
                      {recentResultsMenuItems}
                    </Menu>
                  )}
                </div>
              )}
              <RankingContainer
                tournament={this.props.tournament}
                dia={this.props.dia}
                structureElements={this.props.structureElements}
                divisions={this.props.divisions}
                teams={this.props.teams}
                fontSize={fontSize}
                ranking={this.props.ranking}
              />
              {this.props.players.length > 0 &&
                Object.keys(this.props.tournament.playerPoints || {}).filter(
                  (k) =>
                    (this.props.tournament.playerPoints[k] || {}).type !== "3"
                ).length > 0 && (
                  <PlayerStatsContainer
                    tournament={this.props.tournament}
                    dia={this.props.dia}
                    structureElements={this.props.structureElements}
                    divisions={this.props.divisions}
                  />
                )}
            </div>
          )}
        </div>
      </Paper>
    );
  }
}

export default withTheme(Dia);
